import React from "react";
import ReactDOMServer from "react-dom/server";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import PreviewPopover from "./PreviewPopover";

class PreviewPopoverLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      data: null,
    };

    this.onClick = this.onClick.bind(this);
  }

  componentDidMount() {
    $(this.refs.link).popover({
      content: ReactDOMServer.renderToStaticMarkup(
        <div style={{ padding: "15px" }}>
          <LoadingSpinner loading={!this.state.loaded} size="small" />
        </div>
      ),
      html: true,
      placement: this.props.placement || "auto",
    });

    $("body").on("click", function (e) {
      $("[data-toggle=popover]").each(function () {
        if (
          (!$(this).is(e.target) &&
            $(this).has(e.target).length === 0 &&
            $(".popover").has(e.target).length === 0) ||
          e.target.classList.contains("modal-iframe")
        ) {
          $(this).popover("hide");
        }
      });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.loaded &&
      !prevState.loaded &&
      this.props.renderActiveReact
    ) {
      this.setState({ loaded: false }, () =>
        ReactDOM.render(
          <PreviewPopover {...this.props} data={this.state.data} />,
          $(`#popover-${this.props.report_details.id}`)[0]
        )
      );
    }
  }

  render() {
    return (
      <a
        href="#"
        className={this.props.className}
        style={this.props.style}
        onClick={this.onClick}
        data-toggle="popover"
        ref="link"
        key="link"
      >
        {this.props.children || this.props.text}
      </a>
    );
  }

  onClick() {
    var self = this;
    var data = {};

    if (this.props.model_type == "reservation_segment") {
      data = {
        status: this.props.status,
      };
    }

    if (!this.state.loaded) {
      $.ajax({
        type: "POST",
        url: this.popoverURL(),
        data: data,
      }).done(function (data) {
        if (self.props.renderActiveReact) {
          $(self.refs.link).popover("dispose");
          $(self.refs.link).popover({
            content: `<div id="popover-${self.props.model_id}"></div>`,
            html: true,
            placement: "bottom",
          });
          $(self.refs.link).popover("show");
          self.setState({ loaded: true, data: data });
        } else {
          $(self.refs.link).popover("dispose");
          $(self.refs.link).popover({
            content: ReactDOMServer.renderToStaticMarkup(
              <PreviewPopover {...self.props} {...data} />
            ),
            html: true,
            placement: self.props.placement || "auto",
            sanitize: false,
          });
          $(self.refs.link).popover("show");
        }
      });
    }
  }

  popoverURL() {
    if (this.props.apiEndpoint) {
      return `/api/v1/reports/${this.props.model_type}s/${this.props.model_id}/popover_preview`;
    } else if (this.props.popoverEndpoint) {
      return this.props.popoverEndpoint;
    } else {
      return `/admin/${this.props.model_type}s/${this.props.model_id}/popover_preview`;
    }
  }
}

export default PreviewPopoverLink;
